import React from 'react';

const ICONS = {
  select: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path d="M3 2l10 5-4 1-1 4-5-10z" fill="currentColor" />
    </svg>
  ),
  draw: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path
        d="M3 13l3-1 7-7-2-2-7 7-1 3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  ),
  measure: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path
        d="M2 10l8-8 4 4-8 8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M5 8l1 1M7 6l1 1M9 4l1 1"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  ),
};

const TOOLS = [
  { id: 'select', key: 'V', title: 'Select' },
  { id: 'draw', key: 'R', title: 'Draw / edit' },
  { id: 'measure', key: 'M', title: 'Measure' },
];

export default function LocateToolRail({ tool, onToolChange }) {
  return (
    <div className="rail" role="toolbar" aria-label="Locate tools">
      {TOOLS.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`rail-btn${tool === t.id ? ' active' : ''}`}
          title={`${t.title} (${t.key})`}
          aria-pressed={tool === t.id}
          onClick={() => onToolChange(t.id)}
        >
          {ICONS[t.id]}
          <span className="k">{t.key}</span>
        </button>
      ))}
    </div>
  );
}
